export const NFL_DIVISIONS = [
    { key: 'afce', value: 'AFC East', text: 'AFC East' },
    { key: 'afcn', value: 'AFC North', text: 'AFC North' },
    { key: 'afcw', value: 'AFC West', text: 'AFC West' },
    { key: 'afcs', value: 'AFC South', text: 'AFC South' },
    { key: 'nfce', value: 'NFC East', text: 'NFC East' },
    { key: 'nfcn', value: 'NFC North', text: 'NFC North' },
    { key: 'nfcw', value: 'NFC West', text: 'NFC West' },
    { key: 'nfcs', value: 'NFC South', text: 'NFC South' },
];

export const NFL_CONFERENCES = [
    { key: 'nfc', value: 'NFC', text: 'NFC' },
    { key: 'afc', value: 'AFC', text: 'AFC' },
];

export const WEEK_FORECAST = [
    { key: 'current', value: 'current', text: 'Current' },
    { key: 'start', value: 'start', text: 'Season Start' },
];
